import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaBlock } from '../CtaButton';
import { SectionHeading } from './SectionHeading';
import { offerIncludes } from '../../data/content';
import { MOCKUP_URL } from '../../data/images';

/** The offer — the only block with the price and the real checkout button. */
export function OfferSection() {
  return <section id="offer" aria-labelledby="offer-heading" className="scroll-mt-4 bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-24" data-id="element-120" data-mp="1fmmepm1myzg1">
      <div className="mx-auto max-w-5xl" data-id="element-121" data-mp="288ys0ra9606t">
        <SectionHeading id="offer-heading" title="Prête à simplifier la préparation de vos prochains cours ?" data-id="element-122" data-mp="28a0bnk5c3v05" />

        <div className="mx-auto mt-12 max-w-4xl overflow-hidden rounded-[28px] border-2 border-brand-gold/50 bg-white shadow-[0_50px_100px_-50px_rgba(120,96,56,0.55)]" data-id="element-123" data-mp="23g5kxwrbafrk">
          <div className="bg-brand-forest px-6 py-4 text-center" data-id="element-124" data-mp="2w0cjkv0kxrqq">
            <p className="font-body text-[12px] font-bold uppercase tracking-[0.2em] text-brand-ivory" data-id="element-125" data-mp="2r7t5lwxzcule">
              Hair Instructor Ready™ — Édition Française
            </p>
          </div>

          <div className="px-6 py-10 sm:px-12" data-id="element-126" data-mp="3hhed8sggvtuo">
            <img src={MOCKUP_URL} alt="Tout ce qui est inclus dans Hair Instructor Ready" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto block w-full max-w-[460px] object-contain" style={{
            filter: 'drop-shadow(0 24px 28px rgba(120, 96, 56, 0.2))'
          }} data-id="element-127" data-mp="3hg3amvyrcs55" />

            <p className="mt-10 text-center font-body text-[12px] font-bold uppercase tracking-[0.18em] text-brand-gold" data-id="element-128" data-mp="2yoajz875vj0l">
              Votre accès comprend
            </p>
            <ul className="mx-auto mt-5 grid max-w-xl gap-x-8 gap-y-3.5 sm:grid-cols-2" role="list" data-id="element-129" data-mp="2osz58pvr6bsu">
              {offerIncludes.map(item => <li key={item} className="flex items-center gap-3 text-[15px] leading-snug text-brand-charcoal sm:text-[16px]" data-id="element-130" data-mp="n0uc5b2ip8gj">
                  <CheckIcon className="h-4 w-4 flex-none text-brand-cta" strokeWidth={2.5} aria-hidden="true" data-id="element-131" data-mp="1vy17kmyzbjig" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-10 border-t border-brand-charcoal/10 pt-9" data-id="element-132" data-mp="1mwl1grf763k1">
              <CtaBlock label="Oui, je veux gagner du temps !" showPrice data-id="element-133" data-mp="1hxzywlch37sf" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}